import { Antworttyp } from '../api';
import { AntwortTyp } from '../models/Antworttypen';

export function getInputTypeForAntworttyp(antworttyp: Antworttyp): string {
    switch (antworttyp) {
        case AntwortTyp.INT:
        case AntwortTyp.DOUBLE:
            return 'number';
        case AntwortTyp.BOOLEAN:
        case AntwortTyp.STRING:
        default:
            return 'text';
    }
}
export function getInputStepForAntworttyp(antworttyp: Antworttyp): string {
    return antworttyp === AntwortTyp.DOUBLE ? '0.01' : '1';
}


export function getInputPropsForAntworttyp(antworttyp: Antworttyp): Record<string, any> {
    if (antworttyp === AntwortTyp.INT || antworttyp === AntwortTyp.DOUBLE) {
        return { step: getInputStepForAntworttyp(antworttyp) };
    }
    return {};
}

export function isNumericAntworttyp(antworttyp: Antworttyp): boolean {
    return antworttyp === AntwortTyp.INT || antworttyp === AntwortTyp.DOUBLE;
}

export function supportsExpectedValues(antworttyp: Antworttyp): boolean {
    return antworttyp !== AntwortTyp.STRING;
}

